import { ButtonSize, ButtonVariant, IconName, WbButtonCustomEvent, WorkbenchTheme } from '@workbench/core';
import { WbButton, WbIcon } from '@workbench/react';
import { MouseEventHandler, ReactNode } from 'react';

interface BeamButtonProps {
    //Props from WbButton
    disabled?: boolean;
    download?: string;
    href?: string;
    iconOnly?: boolean;
    loading?: boolean;
    onWbblur?: (event: WbButtonCustomEvent<void>) => void;
    onWbfocus?: (event: WbButtonCustomEvent<void>) => void;
    rel?: string;
    size?: ButtonSize;
    target?: string;
    theme?: WorkbenchTheme;
    type?: 'button' | 'submit';
    variant: ButtonVariant;
    //Custom props
    onClick?: MouseEventHandler<HTMLWbButtonElement>;
    children: ReactNode;
    isSaving?: boolean;
    className?: string;
    trailingIcon?: IconName;
    leadingIcon?: IconName;
    style?: React.CSSProperties;
}

function BeamButton(props: Readonly<BeamButtonProps>) {
    const isDisabled = props.disabled || props.isSaving || props.loading ? true : undefined;
    const isLoading = props.isSaving || props.loading ? true : undefined;

    return (
        <WbButton
            disabled={isDisabled}
            download={props.download}
            href={props.href}
            iconOnly={props.iconOnly}
            loading={isLoading}
            onWbblur={props.onWbblur}
            onWbfocus={props.onWbfocus}
            rel={props.rel}
            size={props.size ?? 'l'}
            target={props.target}
            theme={props.theme}
            type={props.type ?? 'button'}
            variant={props.variant}
            onClick={props.onClick}
            className={props.className}
            style={props.style}
        >
            {props.leadingIcon && <WbIcon name={props.leadingIcon} />}
            {props.children}
            {props.trailingIcon && <WbIcon name={props.trailingIcon} />}
        </WbButton>
    );
}

export default BeamButton;
